<template>
  <div>
    <div v-if="loading" class="text-center my-5">
      <b-spinner />
    </div>
    <b-alert v-else-if="loadError" show variant="danger">
      Не удалось загрузить персону
    </b-alert>
    <template v-else>
      <person-header :person="person" @update="onPersonUpdate" />

      <b-card no-body>
        <b-tabs v-model="activeTab" pills card lazy>
          <b-tab title="Фильмография">
            <person-filmography :person-id="person.id" :person-professions="professionTitles" />
          </b-tab>
          <b-tab v-if="person.facts.length" :title="`Факты (${person.facts.length})`">
            <person-facts :facts="person.facts" />
          </b-tab>
          <b-tab title="Фото">
            <person-photos
              :person-id="person.id"
              :current-photo="person.photo || person.poster"
              @select="onPersonUpdate"
            />
          </b-tab>
        </b-tabs>
      </b-card>
    </template>
  </div>
</template>

<script>
import {
  BAlert, BCard, BSpinner, BTab, BTabs,
} from 'bootstrap-vue'
import PersonHeader from '@/views/database/person/PersonHeader.vue'
import PersonFilmography from '@/views/database/person/PersonFilmography.vue'
import PersonFacts from '@/views/database/person/PersonFacts.vue'
import PersonPhotos from '@/views/database/person/PersonPhotos.vue'

export default {
  components: {
    BAlert, BCard, BSpinner, BTab, BTabs, PersonHeader, PersonFilmography, PersonFacts, PersonPhotos,
  },
  data() {
    return {
      person: null,
      loading: true,
      loadError: false,
      activeTab: 0,
    }
  },
  metaInfo() {
    return { title: this.person ? this.person.name_ru : 'Персона' }
  },
  computed: {
    // Тот же порядок, что в шапке: professions из poiskkino, иначе строка profession из КП
    professionTitles() {
      if (this.person.professions.length) return this.person.professions
      return this.person.profession ? this.person.profession.split(',').map(item => item.trim()) : []
    },
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.load()
      },
    },
  },
  methods: {
    load() {
      this.loading = true
      this.loadError = false
      this.activeTab = 0
      this.$http.get(`/person/${this.$route.params.id}`)
        .then(res => { this.person = res.data.data })
        .catch(() => { this.loadError = true })
        .finally(() => { this.loading = false })
    },
    onPersonUpdate(person) {
      this.person = person
    },
  },
}
</script>
